/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Order } from '../../models/order';
import { UpdateMgmtOrderDto } from '../../models/update-mgmt-order-dto';

export interface UpdateOneBaseMgmtOrderControllerOrder$Params {
  id: number;
      body: UpdateMgmtOrderDto
}

export function updateOneBaseMgmtOrderControllerOrder(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtOrderControllerOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<Order>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtOrderControllerOrder.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Order>;
    })
  );
}

updateOneBaseMgmtOrderControllerOrder.PATH = '/api/mgmt-orders/{id}';
